// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "TreeCreateDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { TreeType } from "./tree-type.enum.gen";

export const TreeCreateDtoGenShape = z.strictObject({
  libraryId: z.string(),
  name: z.string(),
  type: z.enum(TreeType),
  startText: z.string(),
  contactText: z.string(),
  disclaimer: z.string(),
  noticeTitle: z.string(),
  noticeHtml: z.string(),
});
